"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  IMG_DIR: 'images',
  ROW_MAX_IDTT: 5,
  ROW_IDTT_LENGTH: 14,
  REMOTE_STORAGE_BUCKET_IMAGE: 'images',
  REMOTE_STORAGE_BUCKET_ICON: 'icons',
  GROUP_TITLE_LENGTH: 64,
  GROUP_SUBTITLE_LENGTH: 64,
  GROUP_DESC_LENGTH: 1024,
  GROUP_TAG_LENGTH: 64,
  ITEM_TITLE_LENGTH: 64,
  ITEM_SUBTITLE_LENGTH: 64,
  ITEM_DESC_LENGTH: 1024,
  COLUMN_SHORT_TEXT_LENGTH: 256,
  COLUMN_NUMBER_LENGTH: 22,
  COLUMN_LONG_TEXT_LENGTH: 2048,
  SEARCH_KEY_LABEL_DIVIDER: '::'
};